import { useEffect, useState } from "react";
import api from "../api";
import { categories } from "../mock";

// Categories an admin has switched off shouldn't be browsable or postable. One fetch, cached.
let cache = null;
let inflight = null;

export const loadDisabledCategories = () => {
  if (cache) return Promise.resolve(cache);
  if (!inflight) {
    inflight = api.get("/config")
      .then((r) => { cache = r.data?.disabledCategories || []; return cache; })
      .catch(() => []);
  }
  return inflight;
};

export const useEnabledCategories = () => {
  const [off, setOff] = useState(cache || []);
  useEffect(() => { loadDisabledCategories().then(setOff); }, []);
  return categories.filter((c) => !off.includes(c.name));
};

export const useEnabledCategoryNames = () =>
  useEnabledCategories().filter((c) => c.name !== "More").map((c) => c.name);
